import React from 'react';
import styles from './StatCard.module.css';

const StatCard = ({ title, value, icon: Icon, trend, trendValue, color = 'primary' }) => {
  return (
    <div className={`${styles.card} ${styles[color]}`}>
      <div className={styles.iconContainer}>
        {Icon && <Icon className={styles.icon} />}
      </div>
      <div className={styles.content}>
        <p className={styles.title}>{title}</p>
        <p className={styles.value}>{value?.toLocaleString() ?? 0}</p>
        {trend && (
          <p className={`${styles.trend} ${trend === 'up' ? styles.up : styles.down}`}>
            {trend === 'up' ? '↑' : '↓'} {trendValue}
          </p>
        )}
      </div>
    </div>
  );
};

export default StatCard;
